// Images
import fiveStepImg from "../../../../assests/images/fiveStepNew.png";

import React from "react";
import ContentCard from "../../../../UI/ContentCard/ContentCard";
// import styled from "styled-components";
// import IconButton from "@material-ui/core/IconButton";
// import Button from "@material-ui/core/Button";
// import Close from "@material-ui/icons/Close";
// import { withStyles } from "@material-ui/core/styles";
// import Typography from "@material-ui/core/Typography";
// import Dialog from "@material-ui/core/Dialog";
// import DialogActions from "@material-ui/core/DialogActions";
// import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";

// const StyledDialog = styled.div``;
//
// const StyledCard = styled.div`
//   display: flex;
//   flex-direction: column;
//   width: 35rem;
//   margin-top: 3rem;
//   box-shadow: 0 2rem 4rem rgba(0, 0, 0, 0.06);
//   border: 1px solid #f4f2f2;
//   // shadow: 0 2rem 6rem rgba(0,0,0,.3)
//
//   // shadow: 0 2rem 6rem rgba(0,0,0,.3)
// `;
//
// const StyledHeader = styled.div`
//   text-transform: uppercase;
//   font-weight: 400;
//   font-size: 18px;
//   padding: 2rem;
//
//   @media (max-width: 800px) {
//     font-size: 15px;
//   }
// `;
//
// const ImageContainer = styled.div`
//   width: 100%;
//   position: relative;
//   height: auto;
// `;
//
// const StyledImage = styled.img`
//   width: 100%;
//   height: 24rem;
//   object-fit: cover;
//   object-position: 50% 100%;
// `;
//
// const StyledButton = styled(Button)`
//   &&& {
//     position: relative;
//     float: right;
//     font-size: 16px;
//     color: gray;
//     padding-right: 4px;
//   }
// `;
//
// const StyledTypo = withStyles({
//   root: {
//     color: "gray",
//     fontWeight: 400,
//     fontSize: "16px",
//     paddingBottom: "1rem",
//     textAlign: "justify"
//   }
// })(Typography);
//
// const BackTitle = styled.h2`
//   color: gray;
//   text-transform: uppercase;
//   font-weight: 400;
//   font-size: 20px;
//   padding: 2rem;
// `;
//
// const Figure = styled.div`
//   display: grid;
//   grid-template-rows: repeat(2, 1fr);
// `;
//
// const ImagePart = styled.div`
//   display: grid;
//   grid-template-rows: repeat(5, 1fr);
//   grid-template-columns: repeat(7, 1fr);
// `;
//
// const Image = styled.img`
//   width: 80%;
//   box-shadow: 0 1.5rem 4rem rgba(0, 0, 0, 0.4);
//   border-radius: 2px;
//   z-index: 10;
//   transition: all 0.2s;
//   outline-offset: 2rem;
//
//   &:hover {
//     transform: scale(1.2) translateY(-0.5rem);
//     z-index: 20;
//   }
// `;
//
// const ImageP1 = styled(Image)`
//   grid-row: 2 / 6;
//   grid-column: 2 / 6;
// `;
//
// const ImageP2 = styled(Image)`
//   grid-row: 1 / 4;
//   grid-column: 3 / 7;
// `;
//
// const ImageP3 = styled(Image)`
//   grid-row: 3 / 5;
//   grid-column: 4 / 8;
// `;
//
// const Caption = styled.div`
//   text-align: center;
// `;
//
// class ConceptFiveSteps extends React.Component {
//   state = {
//     open: false,
//     scroll: "paper"
//   };
//
//   handleClickOpen = scroll => () => {
//     this.setState({ open: true, scroll });
//   };
//
//   handleClose = () => {
//     this.setState({ open: false });
//   };
//
//   render() {
//     return (
//       <StyledDialog>
//         <StyledCard>
//           <StyledHeader>THE MODEL IN FIVE STEPS</StyledHeader>
//           <ImageContainer>
//             <StyledImage src={fiveStepImg} alt="the five steps" />
//           </ImageContainer>
//           <div>
//             <StyledButton
//               aria-label="More"
//               variant="text"
//               onClick={this.handleClickOpen("paper")}
//             >
//               More
//               <KeyboardArrowRight />
//             </StyledButton>
//           </div>
//         </StyledCard>
//
//         <Dialog
//           open={this.state.open}
//           onClose={this.handleClose}
//           scroll={this.state.scroll}
//           aria-labelledby="scroll-dialog-title"
//         >
//           <BackTitle id="scroll-dialog-title">{this.props.title}</BackTitle>
//           <DialogContent>
//             <DialogContentText>
//               <StyledTypo>
//                 You decide about the design of your hoodie (1). You can choose
//                 your favourite colors, pattern, accessories, print design,
//                 pockets and so on. You put your piece into the cart, pay and
//                 then we produce and ship it to your home. Either that‘s it and
//                 you keep your hoodie as a unique product, or you post your piece
//                 on social media and the SAMPELL platform and offer it to others
//                 (2). When other people order your designed piece, we collect all
//                 the orders within two weeks (3), we produce and ship to all
//                 those customers (4). For every item of your design sold you will
//                 receive a share of the revenue and earn money (5).
//               </StyledTypo>
//             </DialogContentText>
//           </DialogContent>
//           <DialogActions>
//             <IconButton onClick={this.handleClose} color="gray">
//               <Close />
//             </IconButton>
//           </DialogActions>
//         </Dialog>
//       </StyledDialog>
//     );
//   }
// }

const ConceptFiveSteps = () => (
  <ContentCard
    title="THE MODEL IN FIVE STEPS"
    id="fiveSteps"
    image={fiveStepImg}
    imageTitle="THE MODEL IN FIVE STEPS"
    backTextOne="You decide about the design of your product (1). You can choose your favourite colors, pattern,
          accessories, print design, pockets and so on.  You put your piece into the cart, pay and then we
          produce and ship it to your home. Either that‘s it and you keep your hoodie as a unique product, or you post
          your piece on social media and the SAMPELL platform and offer it to others (2). When other people order your designed piece,
          we collect all the orders within two weeks (3), we produce and ship to all those customers (4). For every item of your design sold
          you will receive a share of the revenue and earn money (5)."
  />
);

export default ConceptFiveSteps;



// WEBPACK FOOTER //
// ./src/components/Pages/Concept/Content/ConceptFiveSteps.js